import type { ProgramData, ProgramEntry } from './schema';

let cache: ProgramData | null = null;

export async function loadProgramData(): Promise<ProgramData> {
  if (cache) return cache;
  const res = await fetch('/data/programs.json');
  if (!res.ok) throw new Error(`failed to load programs.json: ${res.status}`);
  cache = (await res.json()) as ProgramData;
  return cache;
}

export function byCategory(data: ProgramData): Map<string, ProgramEntry[]> {
  const map = new Map<string, ProgramEntry[]>();
  for (const cat of data.categories) map.set(cat, []);
  for (const p of data.programs) {
    if (!map.has(p.category)) map.set(p.category, []);
    map.get(p.category)!.push(p);
  }
  return map;
}
